var map = {
	"./IMG_0100.jpeg": 2079,
	"./cabinet.14f14cc0.png": 4940,
	"./wood20.21bed965.png": 4958,
	"./wood25.58480e28.jpg": 6911,
	"./wood5.5d4a4567.JPG": 3273,
	"./wood6.d6d8a793.JPG": 3988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8878;